import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, vModelRadio as _vModelRadio, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  id: "player-boards",
  class: "player-boards",
  "aria-labelledby": "board-title"
}
const _hoisted_2 = {
  id: "board-title",
  class: "sr-only"
}
const _hoisted_3 = {
  key: 0,
  class: "board-invitation",
  "aria-labelledby": "invitation-title"
}
const _hoisted_4 = { class: "invitation-copy" }
const _hoisted_5 = { class: "invitation-context" }
const _hoisted_6 = { id: "invitation-title" }
const _hoisted_7 = { class: "invitation-description" }
const _hoisted_8 = { class: "invitation-actions" }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = { class: "invitation-note" }
const _hoisted_11 = {
  class: "party-table",
  "aria-hidden": "true"
}
const _hoisted_12 = { class: "party-table-top" }
const _hoisted_13 = { class: "toolbar" }
const _hoisted_14 = { class: "language-filter" }
const _hoisted_15 = ["aria-label"]
const _hoisted_16 = { value: "" }
const _hoisted_17 = ["value"]
const _hoisted_18 = { class: "language-options" }
const _hoisted_19 = ["aria-pressed"]
const _hoisted_20 = ["aria-pressed", "onClick"]
const _hoisted_21 = { "aria-hidden": "true" }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { class: "quick-filters" }
const _hoisted_24 = { value: "" }
const _hoisted_25 = { value: "voice" }
const _hoisted_26 = { value: "text" }
const _hoisted_27 = {
  key: 0,
  class: "check-filter"
}
const _hoisted_28 = ["disabled"]
const _hoisted_29 = {
  key: 1,
  class: "board-profile-prompt",
  "aria-labelledby": "profile-prompt-title"
}
const _hoisted_30 = { class: "profile-prompt-copy" }
const _hoisted_31 = { id: "profile-prompt-title" }
const _hoisted_32 = ["disabled"]
const _hoisted_33 = { class: "board-how" }
const _hoisted_34 = { key: 0 }
const _hoisted_35 = {
  key: 2,
  class: "notice"
}
const _hoisted_36 = {
  key: 3,
  role: "status"
}
const _hoisted_37 = {
  key: 4,
  role: "alert"
}
const _hoisted_38 = {
  key: 6,
  role: "status",
  class: "notice"
}
const _hoisted_39 = {
  key: 9,
  class: "empty",
  role: "status"
}
const _hoisted_40 = {
  key: 10,
  class: "empty",
  role: "alert"
}
const _hoisted_41 = {
  key: 0,
  class: "empty"
}
const _hoisted_42 = {
  key: 1,
  class: "pagination"
}
const _hoisted_43 = ["disabled"]
const _hoisted_44 = ["disabled"]
const _hoisted_45 = { class: "giveaway-note" }
const _hoisted_46 = { class: "report-heading" }
const _hoisted_47 = { class: "report-symbol" }
const _hoisted_48 = { id: "report-dialog-title" }
const _hoisted_49 = { class: "report-context" }
const _hoisted_50 = ["disabled"]
const _hoisted_51 = ["value"]
const _hoisted_52 = {
  key: 0,
  role: "alert",
  class: "report-error"
}
const _hoisted_53 = { class: "report-actions" }
const _hoisted_54 = ["disabled"]
const _hoisted_55 = ["disabled"]

import GiveawayTime from '../support/GiveawayTime.vue';
import { computed, defineAsyncComponent, nextTick, onMounted, onBeforeUnmount, ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { useStore } from '@/store';
import { useRoute, useRouter } from 'vue-router';
import { clearBoardDraft } from './board-form-session';
import { BOARD_LANGUAGES, BOARD_REPORT_REASONS } from '@avalon/types/player-board';
import type {
  BoardKind,
  BoardListing,
  BoardDraft,
  BoardAction,
  BoardPage,
  BoardOwnerState,
  BoardReportReason,
} from '@avalon/types/player-board';
import { boardRequest } from '@/api/player-boards';
import { listingState, publicQuery, boardClientError } from './board-helpers';
import { prerender } from '@/helpers/prerender';
import eventBus from '@/helpers/event-bus';
import { languageFlags } from './board-display';
import ReportIcon from './ReportIcon.vue';
import BoardCard from './BoardCard.vue';
import LocaleLink from '@/components/feedback/LocaleLink.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'PlayerBoards',
  props: {
    kind: {}
  },
  setup(__props: any) {

const BoardForm = defineAsyncComponent(() => import(/* webpackChunkName: 'board-form' */ './BoardForm.vue'));
const BoardModeration = defineAsyncComponent(
  () => import(/* webpackChunkName: 'board-moderation' */ './BoardModeration.vue'),
);
const { t } = useI18n();
const store = useStore();
const profile = computed(() => store.state.profile);
const props = __props;
const kind = computed(() => props.kind ?? 'solo');
const route = useRoute();
const router = useRouter();
function updateQuery(changes: Record<string, string | undefined>) {
  const query = { ...route.query, ...changes };
  for (const key of Object.keys(query)) if (query[key] === undefined || query[key] === '') delete query[key];
  void router.push({ query });
}
const language = computed({
  get: () => (BOARD_LANGUAGES.some((item) => item.value === route.query.language) ? String(route.query.language) : ''),
  set: (value: string) => updateQuery({ language: value || undefined, page: undefined }),
});
const communication = computed({
  get: () =>
    route.query.communication === 'voice' || route.query.communication === 'text' ? route.query.communication : '',
  set: (value: string) => updateQuery({ communication: value || undefined, page: undefined }),
});
const beginnerFriendly = computed({
  get: () => kind.value === 'group' && route.query.beginnerFriendly === '1',
  set: (value: boolean) => updateQuery({ beginnerFriendly: value ? '1' : undefined, page: undefined }),
});
const page = computed({
  get: () =>
    typeof route.query.page === 'string' && /^[1-9]\d{0,4}$/.test(route.query.page) ? Number(route.query.page) : 1,
  set: (value: number) => updateQuery({ page: value > 1 ? String(value) : undefined }),
});
const hasFilters = computed(() => Boolean(language.value || communication.value || beginnerFriendly.value));
const resetFilters = () =>
  updateQuery({ language: undefined, communication: undefined, beginnerFriendly: undefined, page: undefined });
const hasMore = ref(false);
const listings = ref<BoardListing[]>([]);
const account = ref<BoardOwnerState | null>(null);
const playerListing = computed(() => account.value?.listings.find((item) => item.kind === 'solo'));
const playerProfileTarget = computed(() =>
  playerListing.value ? { name: 'community_solo' } : { name: 'community_solo', query: { publish: '1' } },
);
const own = computed(() => account.value?.listings.find((item) => item.kind === kind.value));
const draftStorageKey = computed(() => `${profile.value?.id}:${kind.value}:${own.value?.id || 'new'}`);
const now = ref(Date.now());
const visibleListings = computed(() =>
  listings.value.filter((item) => item.id !== own.value?.id && listingState(item, now.value) === 'active'),
);
const editing = ref(false);
const publishAfterLogin = ref(false);
const formElement = ref<HTMLElement | null>(null);
const ownListingElement = ref<HTMLElement | null>(null);
const mutationNotice = ref<HTMLElement | null>(null);
async function reveal(element: typeof ownListingElement) {
  await nextTick();
  element.value?.focus({ preventScroll: true });
  element.value?.scrollIntoView({ block: 'start' });
}
const loading = ref(true);
const accountLoading = ref(false);
const busy = ref(false);
const error = ref('');
const loadError = ref('');
const accountError = ref('');
const success = ref('');
const showInvitation = computed(
  () =>
    !loading.value &&
    !loadError.value &&
    !accountLoading.value &&
    !accountError.value &&
    !visibleListings.value.length &&
    !hasFilters.value &&
    page.value === 1 &&
    !own.value &&
    !playerListing.value &&
    !editing.value &&
    !account.value?.banned,
);
const showCompactInvitation = computed(
  () =>
    !loading.value &&
    !accountLoading.value &&
    !accountError.value &&
    !showInvitation.value &&
    !editing.value &&
    (kind.value === 'group' || !own.value) &&
    (!profile.value || (account.value && (!account.value.banned || Boolean(playerListing.value)))),
);
const reportTarget = ref('');
const reportListingName = computed(() => {
  const listing = listings.value.find((item) => item.id === reportTarget.value);
  return listing?.kind === 'group' ? listing.groupName : listing?.name;
});
const reportReason = ref<BoardReportReason>('spam');
const reportError = ref('');
let publicGeneration = 0;
let accountGeneration = 0;
let mounted = false;
let timer: ReturnType<typeof setInterval> | undefined;
function startPublish() {
  if (!profile.value) {
    eventBus.emit(
      'openAuthModal',
      () => {
        if (!mounted) return;
        if (account.value) startPublish();
        else {
          publishAfterLogin.value = true;
          if (!accountLoading.value) void loadAccount();
        }
      },
      'publish_listing',
    );
    return;
  }
  if (!account.value || account.value.banned || (kind.value === 'group' && !account.value.canRecruit)) return;
  editing.value = true;
  void reveal(formElement);
}
async function consumePublishIntent() {
  if (!mounted || kind.value !== 'solo' || route.query.publish !== '1') return;
  if (profile.value && !account.value) return;
  const query = { ...route.query };
  delete query.publish;
  await router.replace({ query });
  if (mounted) startPublish();
}
async function loadPublic() {
  if (!mounted) return;
  const generation = ++publicGeneration;
  loading.value = true;
  loadError.value = '';
  try {
    const result = await boardRequest<BoardPage>(
      publicQuery(kind.value, language.value, page.value, communication.value, beginnerFriendly.value),
    );
    if (generation !== publicGeneration) return;
    listings.value = result.listings;
    hasMore.value = result.hasMore;
  } catch (e) {
    if (generation === publicGeneration) loadError.value = boardClientError(e);
  } finally {
    if (generation === publicGeneration) loading.value = false;
  }
}
async function loadAccount() {
  const generation = ++accountGeneration;
  accountError.value = '';
  if (!profile.value || !mounted) {
    account.value = null;
    accountLoading.value = false;
    return;
  }
  accountLoading.value = true;
  try {
    const result = await boardRequest<BoardOwnerState>('/me');
    if (generation === accountGeneration) {
      account.value = result;
      if (publishAfterLogin.value) {
        publishAfterLogin.value = false;
        startPublish();
      }
      consumePublishIntent();
    }
  } catch (e) {
    if (generation === accountGeneration) accountError.value = boardClientError(e);
  } finally {
    if (generation === accountGeneration) accountLoading.value = false;
  }
}
async function refresh() {
  await Promise.all([loadPublic(), loadAccount()]);
}
async function mutate(path: string, method: string, body: unknown, message: string) {
  if (busy.value) return;
  const token = profile.value?.token;
  const savedDraftKey = draftStorageKey.value;
  busy.value = true;
  error.value = '';
  success.value = '';
  try {
    await boardRequest(path, method, body);
    if (token !== profile.value?.token) return;
    if (method === 'PUT') clearBoardDraft(savedDraftKey);
    editing.value = false;
    success.value = message;
    await refresh();
    await reveal(ownListingElement);
  } catch (e) {
    if (token === profile.value?.token) {
      error.value = boardClientError(e);
      await reveal(mutationNotice);
    }
  } finally {
    busy.value = false;
  }
}
const save = (draft: BoardDraft) => mutate(`/me/${kind.value}`, 'PUT', draft, 'saved');
const act = (action: BoardAction) =>
  mutate(
    `/me/${kind.value}/${action}`,
    'POST',
    undefined,
    { bump: 'bumpedSuccess', hide: 'hiddenSuccess', reactivate: 'reactivatedSuccess' }[action],
  );
async function sendReport() {
  if (busy.value || !reportTarget.value) return;
  busy.value = true;
  reportError.value = '';
  const token = profile.value?.token;
  try {
    await boardRequest(`/${reportTarget.value}/report`, 'POST', { reason: reportReason.value });
    if (token !== profile.value?.token) return;
    reportTarget.value = '';
    success.value = 'reportSent';
  } catch (e) {
    if (token === profile.value?.token) reportError.value = boardClientError(e);
  } finally {
    busy.value = false;
  }
}
watch(kind, () => {
  editing.value = false;
  publishAfterLogin.value = false;
});
watch([kind, language, communication, beginnerFriendly, page], () => {
  error.value = '';
  success.value = '';
  void loadPublic();
});
watch(
  () => profile.value?.token,
  (_token, previousToken) => {
    if (previousToken) publishAfterLogin.value = false;
    editing.value = false;
    account.value = null;
    reportTarget.value = '';
    error.value = '';
    success.value = '';
    void loadAccount();
  },
);
watch(reportTarget, () => {
  reportError.value = '';
  reportReason.value = 'spam';
});
watch(() => route.query.publish, consumePublishIntent);
onMounted(() => {
  if (prerender) return;
  mounted = true;
  consumePublishIntent();
  void refresh();
  timer = setInterval(() => {
    now.value = Date.now();
  }, 30000);
});
onBeforeUnmount(() => {
  mounted = false;
  publicGeneration++;
  accountGeneration++;
  clearInterval(timer);
});

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("h2", _hoisted_2, _toDisplayString(_unref(t)(`playerBoards.${kind.value === 'group' ? 'teams' : 'players'}`)), 1),
    (showInvitation.value)
      ? (_openBlock(), _createElementBlock("aside", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(t)(`playerBoards.${kind.value === 'group' ? 'noTeamsYet' : 'noPlayersYet'}`)), 1),
            _createElementVNode("h3", _hoisted_6, _toDisplayString(_unref(t)('playerBoards.invitationTitle')), 1),
            _createElementVNode("p", _hoisted_7, _toDisplayString(_unref(t)('playerBoards.invitationBody')), 1),
            _createElementVNode("div", _hoisted_8, [
              (kind.value === 'group')
                ? (_openBlock(), _createBlock(LocaleLink, {
                    key: 0,
                    class: "primary invitation-action",
                    to: { name: 'community_solo', query: { publish: '1' } }
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, {
                        icon: "person_add",
                        size: "20",
                        "aria-hidden": "true"
                      }),
                      _createTextVNode(_toDisplayString(_unref(t)('playerBoards.invitationAction')), 1)
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    type: "button",
                    class: "primary invitation-action",
                    disabled: busy.value,
                    onClick: startPublish
                  }, [
                    _createVNode(_component_v_icon, {
                      icon: "person_add",
                      size: "20",
                      "aria-hidden": "true"
                    }),
                    _createTextVNode(_toDisplayString(_unref(t)('playerBoards.invitationAction')), 1)
                  ], 8, _hoisted_9)),
              _createVNode(LocaleLink, {
                class: "invitation-community",
                to: { name: 'community' }
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('playerBoards.communitiesAction')), 1)
                ]),
                _: 1
              })
            ]),
            _createElementVNode("p", _hoisted_10, _toDisplayString(_unref(t)('playerBoards.invitationNote')), 1)
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_v_icon, {
                icon: "groups",
                size: "40"
              })
            ]),
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (seat) => {
              return _createElementVNode("div", {
                key: seat,
                class: _normalizeClass(["party-seat", `party-seat--${seat}`])
              }, [
                (seat !== 1)
                  ? (_openBlock(), _createBlock(_component_v_icon, {
                      key: 0,
                      icon: "person",
                      size: "22"
                    }))
                  : _createCommentVNode("", true)
              ], 2)
            }), 64))
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("fieldset", _hoisted_14, [
        _createElementVNode("legend", null, _toDisplayString(_unref(t)('playerBoards.languages')), 1),
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((language).value = $event)),
          class: "mobile-language-select",
          "aria-label": _unref(t)('playerBoards.languages')
        }, [
          _createElementVNode("option", _hoisted_16, _toDisplayString(_unref(t)('playerBoards.allLanguages')), 1),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(BOARD_LANGUAGES), (item) => {
            return (_openBlock(), _createElementBlock("option", {
              key: item.value,
              value: item.value
            }, _toDisplayString(_unref(languageFlags)[item.value]) + " " + _toDisplayString(_unref(t)(`playerBoards.language_${item.value}`)), 9, _hoisted_17))
          }), 128))
        ], 8, _hoisted_15), [
          [_vModelSelect, language.value]
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("button", {
            type: "button",
            "aria-pressed": language.value === '',
            onClick: _cache[1] || (_cache[1] = ($event: any) => (language.value = ''))
          }, _toDisplayString(_unref(t)('playerBoards.allLanguages')), 9, _hoisted_19),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(BOARD_LANGUAGES), (item) => {
            return (_openBlock(), _createElementBlock("button", {
              key: item.value,
              type: "button",
              "aria-pressed": language.value === item.value,
              onClick: ($event: any) => (language.value = item.value)
            }, [
              _createElementVNode("span", null, [
                _createElementVNode("span", _hoisted_21, _toDisplayString(_unref(languageFlags)[item.value]), 1),
                _createTextVNode(" " + _toDisplayString(_unref(t)(`playerBoards.language_${item.value}`)), 1)
              ]),
              (item.title && _unref(t)(`playerBoards.language_${item.value}`) !== item.title)
                ? (_openBlock(), _createElementBlock("small", _hoisted_22, _toDisplayString(item.title), 1))
                : _createCommentVNode("", true)
            ], 8, _hoisted_20))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_23, [
        _createElementVNode("label", null, [
          _createTextVNode(_toDisplayString(_unref(t)('playerBoards.communication')) + " ", 1),
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((communication).value = $event))
          }, [
            _createElementVNode("option", _hoisted_24, _toDisplayString(_unref(t)('playerBoards.anyCommunication')), 1),
            _createElementVNode("option", _hoisted_25, _toDisplayString(_unref(t)('playerBoards.voice')), 1),
            _createElementVNode("option", _hoisted_26, _toDisplayString(_unref(t)('playerBoards.text')), 1)
          ], 512), [
            [_vModelSelect, communication.value]
          ])
        ]),
        (kind.value === 'group')
          ? (_openBlock(), _createElementBlock("label", _hoisted_27, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((beginnerFriendly).value = $event)),
                type: "checkbox"
              }, null, 512), [
                [_vModelCheckbox, beginnerFriendly.value]
              ]),
              _createTextVNode(_toDisplayString(_unref(t)('playerBoards.beginnerFriendly')), 1)
            ]))
          : _createCommentVNode("", true),
        (hasFilters.value)
          ? (_openBlock(), _createElementBlock("button", {
              key: 1,
              type: "button",
              class: "reset-filters",
              onClick: resetFilters
            }, _toDisplayString(_unref(t)('playerBoards.resetFilters')), 1))
          : _createCommentVNode("", true)
      ]),
      (kind.value === 'group' && account.value?.canRecruit && !account.value.banned && !own.value && !editing.value)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            type: "button",
            disabled: busy.value,
            onClick: startPublish
          }, _toDisplayString(_unref(t)('playerBoards.publishTeam')), 9, _hoisted_28))
        : _createCommentVNode("", true)
    ]),
    (showCompactInvitation.value)
      ? (_openBlock(), _createElementBlock("aside", _hoisted_29, [
          _createElementVNode("div", _hoisted_30, [
            _createElementVNode("h3", _hoisted_31, _toDisplayString(_unref(t)(
              playerListing.value
                ? 'playerBoards.myPlayerProfile'
                : kind.value === 'group'
                  ? 'playerBoards.compactInvitationTitle'
                  : 'playerBoards.invitationTitle',
            )), 1),
            _createElementVNode("p", null, _toDisplayString(_unref(t)(playerListing.value ? 'playerBoards.managePlayerProfile' : 'playerBoards.compactInvitationBody')), 1)
          ]),
          (kind.value === 'group')
            ? (_openBlock(), _createBlock(LocaleLink, {
                key: 0,
                class: "primary invitation-action",
                to: playerProfileTarget.value
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, {
                    icon: playerListing.value ? 'person' : 'person_add',
                    size: "20",
                    "aria-hidden": "true"
                  }, null, 8, ["icon"]),
                  _createTextVNode(" " + _toDisplayString(_unref(t)(playerListing.value ? 'playerBoards.myProfileAction' : 'playerBoards.invitationAction')), 1)
                ]),
                _: 1
              }, 8, ["to"]))
            : (_openBlock(), _createElementBlock("button", {
                key: 1,
                type: "button",
                class: "primary invitation-action",
                disabled: busy.value,
                onClick: startPublish
              }, [
                _createVNode(_component_v_icon, {
                  icon: "person_add",
                  size: "20",
                  "aria-hidden": "true"
                }),
                _createTextVNode(_toDisplayString(_unref(t)('playerBoards.invitationAction')), 1)
              ], 8, _hoisted_32))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("details", _hoisted_33, [
      _createElementVNode("summary", null, _toDisplayString(_unref(t)('playerBoards.howItWorks')), 1),
      _createElementVNode("p", null, _toDisplayString(_unref(t)('playerBoards.intro')), 1),
      _createElementVNode("p", null, _toDisplayString(_unref(t)('playerBoards.rules')), 1),
      (profile.value && kind.value === 'group' && account.value && !account.value.canRecruit && !account.value.banned)
        ? (_openBlock(), _createElementBlock("p", _hoisted_34, _toDisplayString(_unref(t)('playerBoards.eligibility')), 1))
        : _createCommentVNode("", true)
    ]),
    (account.value?.banned)
      ? (_openBlock(), _createElementBlock("p", _hoisted_35, _toDisplayString(_unref(t)('playerBoards.banned')), 1))
      : _createCommentVNode("", true),
    (accountLoading.value)
      ? (_openBlock(), _createElementBlock("p", _hoisted_36, _toDisplayString(_unref(t)('playerBoards.loading')), 1))
      : _createCommentVNode("", true),
    (accountError.value)
      ? (_openBlock(), _createElementBlock("p", _hoisted_37, [
          _createTextVNode(_toDisplayString(_unref(t)(`playerBoards.${accountError.value}`)) + " ", 1),
          _createElementVNode("button", { onClick: loadAccount }, _toDisplayString(_unref(t)('playerBoards.retry')), 1)
        ]))
      : _createCommentVNode("", true),
    (error.value)
      ? (_openBlock(), _createElementBlock("p", {
          key: 5,
          ref_key: "mutationNotice",
          ref: mutationNotice,
          tabindex: "-1",
          role: "alert",
          class: "notice error"
        }, _toDisplayString(_unref(t)(`playerBoards.${error.value}`)), 513))
      : _createCommentVNode("", true),
    (success.value)
      ? (_openBlock(), _createElementBlock("p", _hoisted_38, _toDisplayString(_unref(t)(`playerBoards.${success.value}`)), 1))
      : _createCommentVNode("", true),
    (editing.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 7,
          ref_key: "formElement",
          ref: formElement,
          tabindex: "-1",
          class: "board-editor"
        }, [
          (editing.value && profile.value && account.value && !account.value.banned)
            ? (_openBlock(), _createBlock(_unref(BoardForm), {
                key: draftStorageKey.value,
                "draft-key": draftStorageKey.value,
                kind: kind.value,
                initial: own.value,
                busy: busy.value,
                onSave: save,
                onCancel: _cache[4] || (_cache[4] = ($event: any) => (editing.value = false))
              }, null, 8, ["draft-key", "kind", "initial", "busy"]))
            : _createCommentVNode("", true)
        ], 512))
      : _createCommentVNode("", true),
    (own.value && !editing.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 8,
          ref_key: "ownListingElement",
          ref: ownListingElement,
          tabindex: "-1",
          class: "own-listing"
        }, [
          _createVNode(BoardCard, {
            listing: own.value,
            owner: "",
            banned: account.value?.banned,
            busy: busy.value,
            now: now.value,
            onEdit: _cache[5] || (_cache[5] = ($event: any) => (editing.value = true)),
            onAction: act
          }, null, 8, ["listing", "banned", "busy", "now"])
        ], 512))
      : _createCommentVNode("", true),
    (loading.value)
      ? (_openBlock(), _createElementBlock("p", _hoisted_39, _toDisplayString(_unref(t)('playerBoards.loading')), 1))
      : (loadError.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
            _createTextVNode(_toDisplayString(_unref(t)(`playerBoards.${loadError.value}`)) + " ", 1),
            _createElementVNode("button", { onClick: loadPublic }, _toDisplayString(_unref(t)('playerBoards.retry')), 1)
          ]))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 11 }, [
            (!visibleListings.value.length && !showInvitation.value && !editing.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                  _createElementVNode("p", null, _toDisplayString(_unref(t)(
              hasFilters.value
                ? 'playerBoards.noFilterMatches'
                : own.value || playerListing.value
                  ? 'playerBoards.noMatches'
                  : 'playerBoards.empty',
            )), 1),
                  (hasFilters.value)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "button",
                        onClick: resetFilters
                      }, _toDisplayString(_unref(t)('playerBoards.resetFilters')), 1))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleListings.value, (listing) => {
              return (_openBlock(), _createBlock(BoardCard, {
                key: listing.id,
                listing: listing,
                busy: busy.value,
                now: now.value,
                "can-report": Boolean(profile.value) && listing.userID !== profile.value?.id,
                onReport: ($event: any) => (reportTarget.value = listing.id)
              }, null, 8, ["listing", "busy", "now", "can-report", "onReport"]))
            }), 128)),
            (page.value > 1 || hasMore.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                  _createElementVNode("button", {
                    disabled: page.value <= 1,
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (page.value--))
                  }, _toDisplayString(_unref(t)('playerBoards.previous')), 9, _hoisted_43),
                  _createElementVNode("span", null, _toDisplayString(page.value), 1),
                  _createElementVNode("button", {
                    disabled: !hasMore.value,
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (page.value++))
                  }, _toDisplayString(_unref(t)('playerBoards.next')), 9, _hoisted_44)
                ]))
              : _createCommentVNode("", true)
          ], 64)),
    _createElementVNode("aside", _hoisted_45, [
      _createElementVNode("strong", null, _toDisplayString(_unref(t)('giveaway.title')), 1),
      _createElementVNode("span", null, [
        _createVNode(GiveawayTime)
      ]),
      _createVNode(LocaleLink, { to: { name: 'support', hash: '#giveaway' } }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('giveaway.rulesTitle')) + " →", 1)
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_v_dialog, {
      "model-value": Boolean(reportTarget.value),
      "max-width": "460",
      persistent: busy.value,
      "aria-labelledby": "report-dialog-title",
      "onUpdate:modelValue": _cache[10] || (_cache[10] = 
        (value) => {
          if (!value && !busy.value) reportTarget.value = '';
        }
      )
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, { class: "report-dialog" }, {
          default: _withCtx(() => [
            _createElementVNode("form", {
              onSubmit: _withModifiers(sendReport, ["prevent"])
            }, [
              _createElementVNode("div", _hoisted_46, [
                _createElementVNode("span", _hoisted_47, [
                  _createVNode(ReportIcon)
                ]),
                _createElementVNode("h2", _hoisted_48, _toDisplayString(_unref(t)('playerBoards.report')), 1)
              ]),
              _createElementVNode("p", _hoisted_49, _toDisplayString(reportListingName.value), 1),
              _createElementVNode("fieldset", {
                class: "report-reasons",
                disabled: busy.value
              }, [
                _createElementVNode("legend", null, _toDisplayString(_unref(t)('playerBoards.reportReason')), 1),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(BOARD_REPORT_REASONS), (reason) => {
                  return (_openBlock(), _createElementBlock("label", {
                    key: reason,
                    class: _normalizeClass({ selected: reportReason.value === reason })
                  }, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((reportReason).value = $event)),
                      type: "radio",
                      name: "board-report-reason",
                      value: reason
                    }, null, 8, _hoisted_51), [
                      [_vModelRadio, reportReason.value]
                    ]),
                    _createElementVNode("span", null, _toDisplayString(_unref(t)(`playerBoards.${reason}`)), 1)
                  ], 2))
                }), 128))
              ], 8, _hoisted_50),
              (reportError.value)
                ? (_openBlock(), _createElementBlock("p", _hoisted_52, _toDisplayString(_unref(t)(`playerBoards.${reportError.value}`)), 1))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_53, [
                _createElementVNode("button", {
                  type: "button",
                  disabled: busy.value,
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (reportTarget.value = ''))
                }, _toDisplayString(_unref(t)('playerBoards.cancel')), 9, _hoisted_54),
                _createElementVNode("button", {
                  type: "submit",
                  class: "primary",
                  disabled: busy.value
                }, _toDisplayString(_unref(t)(`playerBoards.${busy.value ? 'loading' : 'sendReport'}`)), 9, _hoisted_55)
              ])
            ], 32)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model-value", "persistent"]),
    (account.value?.isAdmin)
      ? (_openBlock(), _createBlock(_unref(BoardModeration), {
          key: profile.value?.id,
          onChanged: refresh
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})